module.exports = __webpack_public_path__ + "media/app/images/black-logo-f82d8f607d25ff87d2aed5baddad1b3e.png";